import React, { useEffect } from "react";

const ContactUs = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-28 pb-16">
        {" "}
        {/* Adjusted padding */}
        <div className="max-w-4xl mx-auto px-4">
          {" "}
          {/* Increased max width */}
          <div className="bg-white shadow-sm rounded-lg">
            {" "}
            {/* Added subtle shadow and rounded corners */}
            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/yoel-alvarez-taxsolutionscorp"
              style={{
                minWidth: "320px",
                width: "100%",
                height: "700px", // Reduced height
                border: "none",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
